export default __webpack_public_path__ + "c4a5c377ce0ce11d459c25a140fefcde.jpg";